export default __webpack_public_path__ + "static/media/titulo.0f90083b.png";